import {
  GET_CLUB_SUCCESS,
  CLUB_LIST_REQUESTING,
  CLUB_OBJECT_REQUESTING,
  LIST_CLUBS_SUCCESS,
  RESET_CLUB_ISFETCHING
} from './constants';

const INITIAL_STATE = {
  data: null,
  isListFetching: false,
  isObjectFetching: false
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case RESET_CLUB_ISFETCHING: {
      return {
        ...state,
        isListFetching: false,
        isObjectFetching: false
      };
    }
    case CLUB_LIST_REQUESTING: {
      return {
        ...state,
        isListFetching: true
      };
    }
    case CLUB_OBJECT_REQUESTING: {
      return {
        ...state,
        isObjectFetching: true
      };
    }
    case LIST_CLUBS_SUCCESS: {
      const data = { ...state.data };

      action.payload.data.forEach((object) => {
        data[object.id] = object;
      });
      return {
        data,
        isListFetching: false
      };
    }
    case GET_CLUB_SUCCESS: {
      const data = { ...state.data };
      data[action.payload.id] = action.payload;
      return {
        data,
        isObjectFetching: false
      };
    }
    default:
      return state;
  }
};

export default reducer;

export const getClubBySlug = (clubs, slug) => {
  if (!clubs.data) {
    return null;
  }
  const clubIds = Object.keys(clubs.data);
  const clubBySlugId = clubIds.find((id) => clubs.data[id].slug === slug);
  if (clubBySlugId) {
    return clubs.data[clubBySlugId];
  }
  return null;
};
